export const actions = {
  async list({ rootState }, params) {
    rootState.loading = true

    const query = [
      `auditoria.uuid=${encodeURIComponent(params.auditoria)}`,
      `habilitado=${params.habilitado === true ? 1 : 0}`,
      'order[createdAt]=desc',
    ].join('&')

    const res = await this.$axios.get(`auditoria_qr_offlines?${query}`)
    rootState.loading = false

    return res.data['hydra:member']
  },

  async create({ rootState }, payload) {
    rootState.loading = true
    const res = await this.$axios.post('auditoria_qr_offlines', payload)
    rootState.loading = false

    return res.data
  },

  async update({ rootState }, payload) {
    rootState.loading = true
    const res = await this.$axios.patch(`auditoria_qr_offlines/${payload.uuid}`, payload.body, {
      headers: {
        'Content-Type': 'application/merge-patch+json',
      },
    })
    rootState.loading = false

    return res.data
  },

  async receive({ rootState }, payload) {
    rootState.loading = true
    const headers = payload.body instanceof FormData ? {} : {
      'Content-Type': 'application/json',
    }
    const res = await this.$axios.post(`auditoria_qr_offlines/${payload.uuid}/recepcion`, payload.body, {
      headers,
    })
    rootState.loading = false

    return res.data
  },
}
